import { render } from "./card-list-kulioner.vue?vue&type=template&id=2a6e29d4&scoped=true&ts=true"
import script from "./card-list-kulioner.vue?vue&type=script&lang=ts"
export * from "./card-list-kulioner.vue?vue&type=script&lang=ts"

import "./card-list-kulioner.vue?vue&type=style&index=0&id=2a6e29d4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6e29d4"]])

export default __exports__